@if (sections()) {
  <div class="hours-column">
    <div
      class="blank-group-block"
      [class.with-group]="withGroup()"
    ></div>
    @for (day of sections(); track day.day) {
      <div
        class="section section-agenda"
        [style.height.px]="day.height"
        [style.background-color]="day.backgroundColor"
        [class.current]="day.isCurrentDay"
        [class.grayed]="day.grayed"
      >
        <div class="content">
          <div class="day">
            {{ day.day }}
          </div>
          <div class="right">
            <div class="day-week">
              {{ day.weekDay }}
            </div>
            <div class="month">
              {{ day.month }}
            </div>
          </div>
        </div>
        @if (day.isCurrentDay) {
          <div class="corner top-left"></div>
        }
      </div>
    }
  </div>
}
